
  import login from '~/mixins/common/pages/login'
  export default {
    name: 'Login',
    mixins: [login],
    middleware: 'auth',
    data: () => ({
      loginModal: false,
      valid: false,
      showPassword: false,
      form: {
        player_id: null,
        password: null
      },
      loginLoading: false
    }),
    computed: {
      loading() {
        return this.$store.state.player.loading
      }
    },
    mounted() {
      this.loginModal = true
    },
    methods: {
      doClickOutsize() {
        this.$router.push('/')
      }
    }
  }
